import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../../../../utils/storeApp";
import CallAPI from "../../../../../services/apiCalls";
import $ from "jquery";
import SharedCalGuide from "../../../SharedCalGuide";

const UserAccountHistorySearch = () => {
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [performedBy, setPerformedBy] = useState("");
  const [activityType, setActivityType] = useState("");
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  useEffect(() => {
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
        $("#endDate").datepicker("setDate", new Date());
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek(true));
    $("#endDate").datepicker("setDate", new Date(getLastWeek()));
    setEndDate(new Date());
    setStartDate(new Date(getLastWeek(true)));
  }, []);
  const getLastWeek = (flag) => {
    let today = new Date();
    let month = flag ? today.getMonth() - 3 : today.getMonth();
    let lastWeek = new Date(today.getFullYear(), month, today.getDate());
    return lastWeek;
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    $("#endDate").datepicker("setStartDate", dt);
    $("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };
  const userHistory = async () => {
    let el = sharedObject.UserActiviyHistory;
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    let search = {
      EventDomain: el.EventDomain,
      EventValue: el.EventValue,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
      Actor: performedBy,
      EventType: activityType,
    };
    SetProcessing(true);
    let call =
      "/reports/UserHistory?current=1&sortDir=SentDate&sortBy=SentDate";
    const res = await CallAPI(call, search, "post", userToken);
    SetProcessing(false);
    if (res.status === "SUCCESS") {
      let obj = { ...search, List: res.data.data.result.pageItems };
      SetSharedObject("UserActiviyHistory", obj);
      CloseModal();
    }
    };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
  let timer;
  if (processing) {
    timer = setTimeout(() => {
      setLoadingText("Working on it...");
    }, 10000);
  } else {
    setLoadingText("Loading...");
  }

  return () => clearTimeout(timer); 
  }, [processing]);

  const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

      $('#userActivityHistorySearchModal').modal('hide');
    };
  return (
    <div className="UserAccountHistorySearch">
      <div
        className="modal fade"
        id="userActivityHistorySearchModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="User Activity History Search"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Search
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="field-wrapper">
                    <label htmlFor="username">Performed By</label>
                    <input
                      className="form-control"
                      autoComplete="off"
                      value={performedBy}
                      onChange={(el) => setPerformedBy(el.target.value)}
                    />
                  </div>
                  {/* Calendar */}
                  <div className="field-wrapper">
                    {/* Start Date */}
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label htmlFor="StartDate">Start Date</label>
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date"
                        data-provide="datepicker"
                        id="startDate"
                        data-date-end-date="1d"
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="StartDate"
                          autoComplete="off"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="spacer-inline w-md2">
                      <label htmlFor="EndDate">End Date</label>
                      <i className="bi bi-asterisk rd-clr"></i>
                      <div
                        className="input-group date"
                        data-provide="datepicker"
                        id="endDate"
                        data-date-start-date={minDate}
                        data-date-end-date={maxDate}
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="EndDate"
                          autoComplete="off"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text" id="">
                            <i className="fas fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <SharedCalGuide />
                  {/*<div className="field-wrapper">*/}
                  {/*    <label htmlFor="username">Domain</label>*/}
                  {/*    <input className="form-control" />*/}
                  {/*</div>*/}

                  <div className="field-wrapper">
                    <label htmlFor="">Activity Type</label>
                    <select
                      className="form-control"
                      name=""
                      value={activityType}
                      onChange={(el) => setActivityType(el.target.value)}
                    >
                      <option value="">Search By</option>
                      <option value="UserAccountCreated">
                        Account Created
                      </option>
                      <option value="UserAccountUpdated">
                        Account Updated
                      </option>
                      <option value="UserLocked">Account Locked</option>
                      <option value="UserPasswordChange">
                        Password Changed
                      </option>
                      <option value="UserPasswordReset">Password Reset</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={userHistory}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Cancel
                </button>
                {processing && (
                    <div 
                        className="loader-container" 
                        role="status" 
                        aria-live="polite" 
                        aria-atomic="true"
                        aria-labelledby="loader-id"
                    >
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text" id="loader-id">{loadingText}</div>
                    </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAccountHistorySearch;
